import { useEffect } from "react";
import { LoadingShim } from "@narmi/design_system";
import { entities } from "byzantine";
import useCardLinkedOffersFeature from "../../CardLinkedOffers/hooks";
import { useSubscriptionCards } from "../../contexts/SubscriptionCardsContext";
import CardOffers from "./CardOffers";

interface CardOffersContainerProps {
  maxOffers?: number;
}

const CardOffersContainer = ({ maxOffers }: CardOffersContainerProps) => {
  const isCardLinkedOffersEnabled = useCardLinkedOffersFeature();
  const { cards, isLoading: cardsLoading } = useSubscriptionCards();
  const { fetchEnrollmentStatus, loading: enrollmentLoading } =
    entities.cardLinkedOffers.useFetchCardLinkedOffersEnrollment();
  const { fetchOffers, loading: offersLoading } =
    entities.cardLinkedOffers.useFetchCardLinkedOffers();
  const isEnrolled =
    entities.cardLinkedOffers.useCardLinkedOffersEnrollmentStatus();

  useEffect(() => {
    if (isCardLinkedOffersEnabled) {
      fetchEnrollmentStatus();
    }
  }, [isCardLinkedOffersEnabled, fetchEnrollmentStatus, fetchOffers]);

  useEffect(() => {
    if (isEnrolled) {
      fetchOffers(true);
      fetchOffers(false);
    }
  }, [isEnrolled]);

  // Dont render feature if cards request still loading
  if (cardsLoading) {
    return null;
  }

  // Don't render if feature flag is disabled
  if (!isCardLinkedOffersEnabled || !cards.length) {
    return null;
  }

  const isLoading = enrollmentLoading || offersLoading;

  return (
    <LoadingShim isLoading={isLoading}>
      <div style={{ minHeight: 200 }}>
        <CardOffers maxOffers={maxOffers} />
      </div>
    </LoadingShim>
  );
};

export default CardOffersContainer;
